module.exports = __webpack_public_path__ + "static/hero1-1e3cd0c0f271bc4624f6ccad85bc3115.jpg";